import styled from "styled-components";

const StyledRect = styled.rect`
  fill: ${(props) => props.theme.backgroundColor};
`

const Alert = ({num}) => {

   const alertImages = [
      <g>
         <path d="M2154.33,3246.39h-36.82l-83.83,145.19c8.19,14.17,10.23,17.71,18.41,31.88h167.66l18.4-31.88Zm-10.52,148.35H2128V3379h15.78Zm.3-60.74-2.09,37.67h-12.21l-2.08-37.67v-43.47h16.38Z"/>
         <g>
            <StyledRect x="2238.15" y="3198.51" width="151.94" height="151.94"/>
            <path d="M2380.69,3208.51v132.54H2248.15V3208.51h132.54m10-10H2238.15v152.54h152.54V3198.51Z"/>
            <path d="M2309.67,3247.16h-17.25v-11.7c13.95,0,18.9-3,22.65-13.2h11.1v105h-16.5Z"/>
         </g>
      </g>,

      <g>
         <path d="M3361.29,1851h-36.82l-83.83,145.19,18.41,31.89H3426.7c8.19-14.17,10.23-17.72,18.41-31.89Zm-10.52,148.36H3335v-15.78h15.78Zm.29-60.74-2.08,37.66h-12.21l-2.08-37.66v-43.47h16.37Z"/>
         <g>
            <StyledRect x="3445.11" y="1803.1" width="151.94" height="151.94"/>
            <path d="M3587.65,1813.1v132.53H3455.11V1813.1h132.54m10-10H3445.11v152.53h152.54V1803.1Z"/>
            <path d="M3516.63,1851.74h-17.25V1840c13.95,0,18.9-3,22.65-13.2h11.1v105h-16.5Z"/>
         </g>
      </g>,

      <g>
         <path d="M3153.57,765.41h-36.81L3032.93,910.6l18.41,31.88H3219l18.41-31.88Zm-10.51,148.35h-15.79V898h15.79Zm.29-60.74-2.08,37.67h-12.21L3127,853V809.55h16.37Z"/>
         <g>
            <StyledRect x="3237.4" y="717.53" width="151.94" height="151.94"/>
            <path d="M3379.94,727.53V860.07H3247.4V727.53h132.54m10-10H3237.4V870.07h152.54V717.53Z"/>
            <path d="M3308.92,766.18h-17.25v-11.7c13.95,0,18.9-3,22.65-13.2h11.1v105h-16.5Z"/>
         </g>
      </g>,

      <g>
         <path d="M871.09,186.11H834.27L750.44,331.3c8.19,14.17,10.23,17.71,18.41,31.88H936.51l18.4-31.88ZM860.57,334.46H844.79V318.68h15.78Zm.3-60.74-2.09,37.66H846.57l-2.08-37.66V230.25h16.38Z"/>
         <g>
            <StyledRect x="954.91" y="138.23" width="151.94" height="151.94"/>
            <path d="M1097.45,148.23V280.77H964.91V148.23h132.54m10-10H954.91V290.77h152.54V138.23Z"/>
            <path d="M1026.43,186.87h-17.25V175.18c14,0,18.9-3,22.65-13.2h11.1V267h-16.5Z"/>
         </g>
      </g>,

      <g>
         <path d="M412.19,1339.26H375.37l-83.82,145.19,18.4,31.89H477.61L496,1484.45Zm-10.52,148.36H385.89v-15.78h15.78Zm.3-60.74-2.08,37.66H387.68l-2.08-37.66v-43.47H402Z"/>
         <g>
            <StyledRect x="496.02" y="1291.39" width="151.94" height="151.94"/>
            <path d="M638.55,1301.39v132.53H506V1301.39H638.55m10-10H496v152.53H648.55V1291.39Z"/>
            <path d="M567.53,1340H550.28v-11.7c14,0,18.9-3,22.65-13.2H584v105h-16.5Z"/>
         </g>
      </g>
   ]

  const index = num-1
  return (
    alertImages[index]
  )
}

export default Alert
